import styled from 'styled-components';

import { FlexRowCenterVertical, StyleUtils } from '@main/core-ui';

export const DraftPrivacyCenterBannerWrapper = styled(FlexRowCenterVertical)`
  background-color: ${({ theme }) => theme.colors.transcendNavy};
  color: ${({ theme }) => theme.colors.white};
  padding: ${StyleUtils.Spacing.sm};
  gap: ${StyleUtils.Spacing.sm};
`;
